function cleanTag(tag) {
  if (tag.startsWith('#'))
    return tag;
  return tag.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^\w\s]|_/g, '').replace(/\s+/g, ' ').toLowerCase();
}

export { cleanTag };
